module.exports = __webpack_public_path__ + "img/special_liftserum_202309.707888d5.jpg";